import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-popover-content',
  // template: '<div #container  class="ion-padding"></div>',
  templateUrl: './popover-content.component.html',
  styleUrls: ['./popover-content.component.scss'],
})
export class PopoverContentComponent  implements OnInit {

  @ViewChild('container') container: ElementRef;
  @Input() contentElement: string;
  @Input() action: () => void;
  @Input() close: () => void;
  @Input() next: () => void;
  @Input() back: () => void;
  @Input() onUpdate: Subject<string>;
  @Input() hideForwardButton: boolean = false;
  @Input() hideBackButton: boolean = false;
  @Input() hideCloseButton: boolean = false;
  @Input() pagination: {current: number; total: number};
  @Input() title: string;


  constructor(private renderer: Renderer2) {}

  ngOnInit() {}
  
  ngAfterViewInit() {
    const element = this.renderer.createElement('div');
    this.renderer.setProperty(element, 'innerHTML', this.contentElement);
    this.renderer.appendChild(this.container.nativeElement, element);
    if (this.action) this.action();
  }

  nextAction() {
    if (this.next) this.next();
  }

  backAction() {
    if (this.back) this.back();
  }

  @HostListener('window:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'ArrowRight') {
      this.nextAction();
    } else if (event.key === 'ArrowLeft') {
      this.backAction();
    }
  }

}
